import { Record } from 'immutable';
export default Record({
  senderId: null,
  senderType: null
}, 'SenderLocator');